import { inject, Injector, Signal, TemplateRef } from '@angular/core';
import { ModalService } from '../modal.service';
import { Dismissed, ResolvableModalConfig } from '../types/modal-config';
import { ConfirmResult } from '../types/confirm-result';
import { ConfirmModalComponent } from '../components/confirm-modal/confirm-modal.component';

export interface ConfirmModalConfig2 {
  title?: string | Signal<string | null>;
  subtitle?: string | Signal<string | null>;
  content?: TemplateRef<any> | Signal<TemplateRef<any> | null>;
  contentContext?: object | Signal<object | null>;
  contentText: string | Signal<string>;
  showAbort?: boolean;
  class?: string;
  dismiss?: boolean;
  dismissOnNavigation?: boolean;
}

async function confirm(
  modalService: ModalService,
  config: ConfirmModalConfig2,
  injector: Injector
): Promise<ConfirmResult | Dismissed> {
  const modalConfig: ResolvableModalConfig<ConfirmModalComponent, ConfirmResult> = {
    component: ConfirmModalComponent,
    dismiss: config.dismiss,
    title: config.title ?? 'Frage',
    subtitle: config.subtitle,
    text: config.contentText,
    template: config.content,
    templateContext: config.contentContext,
    priority: Number.POSITIVE_INFINITY,
    data: {
      showAbort: config.showAbort,
    },
    class: config.class,
    injector: injector,
    dismissOnNavigation: config.dismissOnNavigation ?? true,
  };
  return await modalService.open(modalConfig);
}

export function confirmFn(): (
  config: ConfirmModalConfig2
) => Promise<ConfirmResult | Dismissed> {
  const modalService = inject(ModalService);
  const injector = inject(Injector);
  return (config) => confirm(modalService, config, injector);
}
